import type React from 'react';
import { useTranslation } from 'react-i18next';
import type { FixedAssetStatus } from '@/api/models';
import { cn } from '@/utils/cnUtils';
import { getNodeTestIdProp } from '@/utils/nodeTestProps';
import { ASSET_STATUS_CHIP } from '../../fixedAssetsMeta';

type AssetStatusChipProps = {
    status: FixedAssetStatus;
    /** Row discriminator, appended after the literal testid prefix. */
    slot: string;
};

/**
 * Active / Disposed, in the journal's calm vocabulary. A disposal is a normal
 * end of life, so Disposed is muted and settled — never danger.
 */
export const AssetStatusChip: React.FC<AssetStatusChipProps> = ({
    status,
    slot,
}) => {
    const { t } = useTranslation('pages');
    const chip = ASSET_STATUS_CHIP[status];

    return (
        <span
            className={cn(
                'inline-flex w-fit items-center rounded-lg px-2.5 py-1 text-xs font-medium',
                chip.className,
            )}
            {...getNodeTestIdProp(`fixed-assets-status-chip-${slot}`)}
        >
            {t(chip.labelKey)}
        </span>
    );
};
